import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import { RightTooltip } from 'ui/tooltip';
import { TrackingDomainRowData } from '../types';

type Props = {
  onDelete: (rowData: TrackingDomainRowData) => void;
  onEdit: (rowData: TrackingDomainRowData) => void;
  onSetDefault: (rowData: TrackingDomainRowData) => void;
  rowData: TrackingDomainRowData;
};

const TEXT = {
  defaultCTA: 'Set as default',
  deleteCTA: 'Delete',
  disabledDeleteTooltip:
    "This tracking domain is still in use. Before you can delete it, you'll need to update or delete the templates that use it for link shortening.",
  editCTA: 'Edit',
};

export const TrackingDomainsTableActionButton = ({
  onDelete = () => null,
  onEdit = () => null,
  onSetDefault = () => null,
  rowData,
}: Props) => {
  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: <span data-test="mailDomains-edit-tracking-domain-button">{TEXT.editCTA}</span>,
      id: 'edit-key-action',
      onClick: () => onEdit(rowData),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <span data-test="mailDomains-set-tracking-domain-as-default-button">{TEXT.defaultCTA}</span>
      ),
      id: 'set-default-key-action',
      onClick: () => onSetDefault(rowData),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: <span data-test="mailDomains-delete-tracking-domain-button">{TEXT.deleteCTA}</span>,
      id: 'delete-key-action',
      isDestructive: true,
      isDisabled: rowData.templateIdsWithEnabledLinkShortening?.length > 0,
      onClick: () => onDelete(rowData),
      Wrapper: ({ children }) => (
        <RightTooltip
          tooltipContent={TEXT.disabledDeleteTooltip}
          isEnabled={rowData.templateIdsWithEnabledLinkShortening?.length > 0}
        >
          {children}
        </RightTooltip>
      ),
    },
  ];

  return <OverflowMenu id="tracking-domain-table-action-button" options={options} />;
};
